import type * as React from 'react';

import { Button, CardContent, CircularProgress } from '@mui/material';
import { Login, useSafeSetState, useTranslate } from 'react-admin';

export const LoginPage = (): React.ReactElement => {
  const [loading, setLoading] = useSafeSetState(false);
  const translate = useTranslate();

  const refresh = (): void => {
    // TODO move this call into a separate module so we can mock it
    window.location.reload();
    setLoading(true);
  };

  return (
    <Login>
      <CardContent>
        <h1>{translate('ra.auth.auth_check_error')}</h1>
        <Button onClick={refresh} variant='contained' type='submit' color='primary' disabled={loading} fullWidth>
          {loading === true ? <CircularProgress size={19} thickness={3} /> : translate('ra.auth.sign_in')}
        </Button>
      </CardContent>
    </Login>
  );
};
